export default {

    // ----------------------------------------------------

    apiConnectorSignUpRequest(data) {
        return this.request(this.api().CONNECTOR_SIGNUP_REQUEST, data)
            .exec()
            .log()
            .mapresults((res) => {
                return res;
            })
            .get();
    },

    apiConnectorSignUpVerify(data) {
        return this.request(this.api().CONNECTOR_SIGNUP_VERIFY, data)
            .exec()
            .log()
            .mapresults((res) => {
                return res;
            })
            .get();
    },

    apiConnectorSignUpSubmit(data) {
        return this.request(this.api().CONNECTOR_SIGNUP_SUBMIT, data)
            .exec()
            .log()
            .mapresults((res) => {
                return res;
            })
            .get();
    },

    apiConnectorLoginRequestViaOtp(data) {
        return this.request(this.api().CONNECTOR_LOGIN_REQUEST_VIA_OTP, data)
            .exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiConnectorLoginVerifyViaOtp(data) {
        return this.request(this.api().CONNECTOR_LOGIN_VERIFY_VIA_OTP, data)
            .exec()
            .log()
            .mapresults((response) => {
                return new Promise((resolve, reject) => {
                    // Step 1: Get Connector Details
                    const headers = {
                        authorization: "Bearer " + response.access_token,
                    };

                    const getDetails = this.request(this.api().GET_CONNECTOR_DETAILS, {}, headers).exec().get();
                    const getStatus = this.request(this.api().GET_CONNECTOR_STATUS, {}, headers).exec().get();

                    // Step 2: Wait for both promises
                    Promise.all([getDetails, getStatus])
                        .then(([details, status]) => {
                            console.log("user details", details);
                            console.log("user status", status);

                            let retdata = {
                                auth: response.access_token,
                                logged: {
                                    ...Object.except(data, ["password"]),
                                    ...response,
                                },
                                user: {
                                    ...details,
                                    ...status,
                                    role: "CONNECTOR",
                                    refresh: response.refresh_token,
                                },
                            };

                            resolve(retdata);
                            return retdata;
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            })
            .get();
    },


    apiConnectorLoginViaEmail(data) {
        return this.request(this.api().CONNECTOR_LOGIN_WITH_CREDS, data)
            .exec().log()
            .mapresults((response) => {
                return new Promise((resolve, reject) => {
                    // Step 1: Get Connector Details
                    const headers = {
                        authorization: "Bearer " + response.access_token,
                    };

                    const getDetails = this.request(this.api().GET_CONNECTOR_DETAILS, {}, headers).exec().get();
                    const getStatus = this.request(this.api().GET_CONNECTOR_STATUS, {}, headers).exec().get();

                    // Step 2: Wait for both promises
                    Promise.all([getDetails, getStatus])
                        .then(([details, status]) => {
                            console.log("user details", details);
                            console.log("user status", status);

                            let retdata = {
                                auth: response.access_token,
                                logged: {
                                    ...Object.except(data, ["password"]),
                                    ...response,
                                },
                                user: {
                                    ...details,
                                    ...status,
                                    refresh: response.refresh_token,
                                },
                            };

                            resolve(retdata);
                            return retdata;
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            })
            .get();
    },

    apiGetConnectorStatus() {
        return this.request(this.api().GET_CONNECTOR_STATUS)
            .exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiGetConnectorDetails() {
        return this.request(this.api().GET_CONNECTOR_DETAILS)
            .exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiGetAllConnectors(data) {
        return this.request(this.api().GET_ALL_CONNECTORS, data)
            .exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiGetConnectorLeadsForAdmin(data) {
        return this.request(this.api().GET_CONNECTOR_LEADS_FOR_ADMIN, data)
            .exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiExportConnectors(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().EXPORT_CONNECTORS, payload)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .mapresults((response) => {
                return response;
            })
            .get();
    },

    apiExportAllConnectorLeads(data) {
        let payload = {
            ...data,
        };
        return this.request(this.api().EXPORT_ALL_CONNECTOR_LEADS, payload)
            .responsetype("arraybuffer")
            .exec()
            .log()
            .mapresults((response) => {
                return response;
            })
            .get();
    },

    apiGetConnectorDetailsById(urldata) {
        return this.request(this.api().GET_CONNECTOR_DETAILS_BY_ID)
            .urltransform(urldata).exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiUpdateConnectorDetailsById(data, urldata) {
        return this.request(this.api().UPDATE_CONNECTOR_DETAILS_BY_ID, data)
            .urltransform(urldata).exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiUpdateConnectorDeletionDetailsById(data, urldata) {
        return this.request(this.api().UPDATE_CONNECTOR_DELETION_DETAILS, data)
            .urltransform(urldata).exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiConnectorPasswordReset(data) {
        return this.request(this.api().CONNECTOR_PASSWORD_RESET, data)
            .exec()
            .log()
            .mapresults((res) => {
                return res;
            })
            .get();
    },

    apiGetConnectorDigilockerUrlForUserConsent(data) {
        return this.request(this.api().GET_CONNECTOR_DIGILOCKER_URL_FOR_USER_CONSENT, data)
            .exec().log().mapresults((res) => {
                return res
            }).get();
    },

    apiGetConnectorPanDetails(data) {
        return this.request(this.api().GET_CONNECTOR_PAN_DETAILS, data)
            .exec()
            .log()
            .mapresults((res) => {
                return res;
            })
            .get();
    },

    apiVerifyConnectorPanDetails(data) {
        return this.request(this.api().VERIFY_CONNECTOR_PAN, data)
            .exec()
            .log()
            .mapresults((res) => {
                return res;
            })
            .get();
    },

    apiUpdateConnectorDocs(data) {
        return this.request(this.api().UPDATE_CONNECTOR_DOCS, data)
            .exec().log().get();
    },

    apiSendAgreementToConnectorForEsign(urldata = mixins.params()) {

        return this.request(this.api().SEND_AGREEMENT_TO_CONNECTOR_FOR_ESIGN)
            .urltransform(urldata)
            .exec().log().get();
    },

    apiAddConnectorApplication(data) {

        return this.request(this.api().ADD_CONNECTOR_APPLICATION, data)
            .exec().log().get();
    },

    apiGetConnectorSummaryStatus(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_CONNECTOR_SUMMARY_STATUS, payload)
            .exec().log()
            .get();
    },

    apiGetConnectorApplications(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().GET_CONNECTOR_APPLICATIONS, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.count
                }
            })
            .get();
    },

    apiAddConnectorBankDetails(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().ADD_CONNECTOR_BANK_DETAILS, payload)
            .exec().log()
            .get();
    },

    apiUpdateConnectorBankDetails(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().UPDATE_CONNECTOR_BANK_DETAILS, payload)
            .exec().log()
            .get();
    },
    // ----------------------------------------------------

    apiAddConnectorLead(data) {
        return this.request(this.api().ADD_CONNECTOR_LEADS, data)
            .exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiGetAllConnectorLeads(data) {
        return this.request(this.api().GET_CONNECTOR_LEADS, data)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.count
                }
            })
            .get();
    },

    apiGetConnectorLeadById(urldata) {
        return this.request(this.api().GET_CONNECTOR_LEAD_BY_ID)
            .urltransform(urldata).exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiUpdateConnectorLeadById(data, urldata) {
        return this.request(this.api().UPDATE_CONNECTOR_LEAD_BY_ID, data)
            .urltransform(urldata).exec().log().mapresults((res) => {
                return res;
            })
            .get();
    },

    apiSendConnectorLeadsForPayout(data) {
        return this.request(this.api().SEND_CONNECTOR_LEADS_FOR_PAYOUT, data)
            .exec()
            .log()
            .get();
    },
    // ----------------------------------------------------

    apiGetRegisteredUsers(data) {
        let payload = {
            ...data
        };
        return this.request(this.api().CUSTOMER_INFORMATION, payload)
            .exec().log()
            .mapresults((response) => {
                return {
                    data: response?.data,
                    total: response?.count
                }
            })
            .get();
    },

    apiUploadDocs(data) {
        return this.request(this.api().PROFILE_UPLOAD_DOCS, data)
            .exec().log().get();
    },

    apiUploadCustomerDocs(data) {
        return this.request(this.api().CUSTOMER_UPLOAD_DOCS, data)
            .exec().log().mapresults((res) => {
                return res.data
            }).get();
    },

    apiSendAgreementForEsign(urldata = mixins.params()) {

        return this.request(this.api().SEND_AGREEMENT_FOR_ESIGN)
            .urltransform(urldata)
            .exec().log().get();
    },
}